const MerchantRouter = {
  path: '/merchant',
  name: 'Merchant',
  component: () => import('@/views/merchant/index'),
  children: [
    {
      path: ':id',
      name: 'MerchantHome',
      component: () => import('@/views/merchant/home'),
      meta: { title: '赛事广场' }
    },
    {
      path: 'attend-list/:merchantId',
      name: 'MerchantAttendList',
      component: () => import('@/views/merchant/my-entry-list'),
      meta: { title: '我的参赛' }
    },
    {
      path: 'manage-match-list/:merchantId',
      name: 'MerchantManageMatchList',
      component: () => import('@/views/merchant/manage-match-list'),
      meta: { title: '管理赛事列表' }
    }
  ]
}
export default MerchantRouter
